import React from "react";
import { Provider, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import store from "./redux/store";
import DoctorLoginPage from "./components/DoctorLoginPage";
import DoctorRegisterPage from "./components/DoctorRegisterPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import AdminLogin from "./components/AdminLogin";
import Dashboard from "./components/Dashboard";
import AdminDashboard from "./components/AdminDashboard";
import SubscriptionStatus from "./components/SubscriptionStatus";
import ConsultationPage from "./components/ConsultationPage";
import PatientDetailPage from "./components/PatientDetailPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import "./App.css";

function AppContent() {
  const isDoctorAuthenticated = useSelector(
    (state) => state.auth.isAuthenticated,
  );
  const isAdminAuthenticated = useSelector(
    (state) => state.admin.isAuthenticated,
  );
  const subscriptionActive = useSelector(
    (state) => state.auth.subscriptionActive,
  );

  return (
    <Router>
      <Routes>
        {/* Doctor Auth Routes */}
        <Route path="/login" element={<DoctorLoginPage />} />
        <Route path="/register" element={<DoctorRegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* Admin Auth Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Privacy Policy Route - Publicly Accessible */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Subscription Status Route */}
        {isDoctorAuthenticated && !subscriptionActive ? (
          <Route path="/subscription-status" element={<SubscriptionStatus />} />
        ) : null}

        {/* Doctor Dashboard Routes */}
        {isDoctorAuthenticated && subscriptionActive ? (
          <Route path="/dashboard" element={<Dashboard />} />
        ) : null}

        {/* Consultation Page Route */}
        {isDoctorAuthenticated && subscriptionActive ? (
          <Route path="/consultation/:appointmentId" element={<ConsultationPage />} />
        ) : null}

        {/* Patient Detail Page Route */}
        {isDoctorAuthenticated && subscriptionActive ? (
          <Route path="/patient/:patientId" element={<PatientDetailPage />} />
        ) : null}

        {/* Admin Dashboard Routes */}
        {isAdminAuthenticated ? (
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        ) : null}

        {/* Redirect to login if not authenticated */}
        <Route
          path="/"
          element={
            isDoctorAuthenticated && subscriptionActive ? (
              <Navigate to="/dashboard" />
            ) : isDoctorAuthenticated && !subscriptionActive ? (
              <Navigate to="/subscription-status" />
            ) : isAdminAuthenticated ? (
              <Navigate to="/admin/dashboard" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
